import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Check if we are on a page with a dark hero (most pages)
  const isDarkHero = true; // We'll assume all pages start with a dark hero for this premium feel
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Luxury Homes',
    path: '/residential'
  }, {
    name: 'Resorts & Destinations',
    path: '/resorts'
  }, {
    name: 'Developers',
    path: '/developers'
  }, {
    name: 'Activations',
    path: '/activations'
  }, {
    name: 'Concepts',
    path: '/concepts'
  }, {
    name: 'About',
    path: '/about'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-brand-green-deep py-4 ${isScrolled ? 'shadow-lg' : ''}`} data-id="element-76">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-77">
          {/* Logo */}
          <Link to="/" className="relative z-50 flex flex-col" data-id="element-78">
            <span className="font-heading text-2xl md:text-3xl font-semibold text-brand-cream-light tracking-wide" data-id="element-79">
              PuttLab
            </span>
            <span className="font-body text-[10px] tracking-widest text-brand-gold uppercase mt-0.5" data-id="element-80">
              by TurfsUp!
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8 xl:space-x-10" data-id="element-81">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-body transition-colors relative group ${location.pathname === link.path ? 'text-brand-gold' : 'text-brand-cream-light/80 hover:text-brand-gold'}`} data-id="element-82">
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-[1px] bg-brand-gold transition-all duration-300 ${location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-83" />
              </Link>)}
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center space-x-4 relative z-50" data-id="element-84">
            <div className="hidden md:block" data-id="element-85">
              <Button variant="primary" size="sm" href="/contact" data-id="element-86">
                Book a Design Call
              </Button>
            </div>

            <button className="lg:hidden text-brand-cream-light p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-87">
              {isMobileMenuOpen ? <XIcon size={24} data-id="element-88" /> : <MenuIcon size={24} data-id="element-89" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-90">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-40 bg-brand-green-deep pt-32 px-6 pb-12 flex flex-col overflow-y-auto" data-id="element-91">
            <nav className="flex flex-col space-y-6 mb-12" data-id="element-92">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-3xl font-heading transition-colors ${location.pathname === link.path ? 'text-brand-gold' : 'text-brand-cream-light hover:text-brand-gold'}`} data-id="element-93">
                  {link.name}
                </Link>)}
            </nav>
            <div className="mt-auto" data-id="element-94">
              <Button variant="primary" size="lg" className="w-full" href="/contact" data-id="element-95">
                Book a Design Call
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}